<template>
  <div fluid fill-height>
    <v-container
      class="d-flex justify-center align-center"
      style="min-width: 100% !important; height: 100vh"
    >
      <Autenticacion />
    </v-container>
  </div>
</template>
<script>
import Autenticacion from "../../components/AppAccess/FormTwoFA.vue";

export default {
  components: { Autenticacion },
};
</script>
